// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";
// import DOMPurify from 'dompurify';

// const baseUrl = "https://api.shabdtoday.com/";
// const image_resize = "https://api.shabdtoday.com/api/home/resize";

// const isDesktopScreen = () => window.innerWidth >= 1024;
// const truncateText = (text, maxLength) => {
//   if (text.length > maxLength) {
//     return text.substring(0, maxLength);
//   }
//   return text;
// };

// const truncateHtml = (html, maxLength) => {
//   const tempDiv = document.createElement("div");
//   tempDiv.innerHTML = html;
//   const text = tempDiv.textContent || tempDiv.innerText || "";

//   if (text.length <= maxLength) return html;

//   let charCount = 0;
//   let isTruncated = false;

//   const traverse = (node) => {
//     let newNode;
//     if (node.nodeType === Node.TEXT_NODE) {
//       if (charCount >= maxLength) return document.createTextNode("");
//       const remaining = maxLength - charCount;
//       const truncated = node.textContent.slice(0, remaining);
//       charCount += truncated.length;
//       if (charCount >= maxLength && !isTruncated) {
//         isTruncated = true;
//         newNode = document.createTextNode(truncated + "..."); // append dots
//       } else {
//         newNode = document.createTextNode(truncated);
//       }
//     } else if (node.nodeType === Node.ELEMENT_NODE) {
//       newNode = node.cloneNode(false);
//       node.childNodes.forEach((child) => {
//         if (charCount < maxLength) {
//           newNode.appendChild(traverse(child));
//         }
//       });
//     }
//     return newNode;
//   };

//   const truncatedDiv = traverse(tempDiv);
//   return truncatedDiv.outerHTML;
// };


// const local = "https://localhost:44351/api/home/pliticsKhabars"
// const online = "https://api.shabdtoday.com/api/home/pliticsKhabars"
// const clicklocal = "https://localhost:44351/api/home/update-viewcount"
// const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"

// const stripHtmlTags = (html, maxLength) => {
//   const tempDiv = document.createElement("div");
//   tempDiv.innerHTML = html;
//   const strippedText = tempDiv.textContent || tempDiv.innerText || "";
//   return truncateText(strippedText, maxLength);
// };


// const PoliticsCards = () => {
//   const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
//   const [news, setNews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [fetching, setFetching] = useState(false);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
//   const observer = useRef();

//   const fetchNews = async () => {
//     if (!hasMore || fetching) return;

//     setFetching(true);
//     try {
//       const response = await axios.get(`${online}?page=${page}&limit=5`);

//       if (response.data && response.data.pliticsKhabars.length > 0) {
//         setNews((prevNews) => {
//           const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
//           const newNews = response.data.pliticsKhabars.filter((item) => !existingIds.has(item.mainKhabarId));
//           return [...prevNews, ...newNews];
//         });
//         setPage((prevPage) => prevPage + 1);
//       } else {
//         setHasMore(false);
//       }
//     } catch (error) {
//       console.error("Error fetching news:", error.message);
//     }
//     setFetching(false);
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchNews();
//   }, []);

//   useEffect(() => {
//     observer.current = new IntersectionObserver((entries) => {
//       if (entries[0].isIntersecting) {
//         fetchNews();
//       }
//     });

//     const target = document.getElementById("load-more");
//     if (target) observer.current.observe(target);

//     return () => observer.current && observer.current.disconnect();
//   }, [news]);

//   const renderHtmlContent = (html) => {
//     const sanitizedHtml = DOMPurify.sanitize(html);
//     return { __html: sanitizedHtml };
//   };



//   const handleNewsClick2 = async (slug, mainKhabarId) => {
//     try {
//       const response = await axios.post(`${clickonline}`, {
//         mainKhabarId: mainKhabarId
//       });

//       if (response.status === 200) {
//         console.log("View count updated successfully", response.data);
//         window.location.href =`/News-Details/${slug}`;
//       } else {
//         console.error("Failed to update view count", response.data);
//       }
//     } catch (error) {
//       console.error("Error updating view count:", error.response ? error.response.data : error.message);
//     }
//   };

//   const handleNewsClick = (trendingTagId) => {
//     navigate(`/NewsDetails/${trendingTagId}`);
//   };

//   const formatDateInHindi = (dateString) => {
//     const date = new Date(dateString);
//     const monthsInHindi = [
//       "जनवरी",
//       "फरवरी",
//       "मार्च",
//       "अप्रैल",
//       "मई",
//       "जून",
//       "जुलाई",
//       "अगस्त",
//       "सितंबर",
//       "अक्टूबर",
//       "नवंबर",
//       "दिसंबर",
//     ];
//     const seconds = date.getSeconds();
//     const minute = date.getMinutes();
//     var hour = date.getHours();
//     const day = date.getDate();
//     const month = monthsInHindi[date.getMonth()];
//     const year = date.getFullYear();
//     const amPm = hour >= 12 ? "PM" : "AM";
//     hour = hour % 12 || 12;
//     return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
//   };
//   const getTimeAgoInHindi = (dateString) => {
//     const now = new Date();
//     const past = new Date(dateString);
//     const diffInSeconds = Math.floor((now - past) / 1000);

//     if (diffInSeconds < 60) {
//       return `${diffInSeconds} सेकंड पहले`;
//     }

//     const diffInMinutes = Math.floor(diffInSeconds / 60);
//     if (diffInMinutes < 60) {
//       return `${diffInMinutes} मिनट पहले`;
//     }

//     const diffInHours = Math.floor(diffInMinutes / 60);
//     if (diffInHours < 24) {
//       return `${diffInHours} घंटे पहले`;
//     }

//     const diffInDays = Math.floor(diffInHours / 24);
//     if (diffInDays < 30) {
//       return `${diffInDays} दिन पहले`;
//     }

//     const diffInMonths = Math.floor(diffInDays / 30);
//     if (diffInMonths < 12) {
//       return `${diffInMonths} महीने पहले`;
//     }

//     const diffInYears = Math.floor(diffInMonths / 12);
//     return `${diffInYears} साल पहले`;
//   };

//   const generateShareLinks = (mainKhabarId, newsTag) => {
//     const encodedNewsHeading = encodeURIComponent(newsTag);
//     const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
//     return {
//       facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodedNewsHeading}`,
//       whatsapp: `https://api.whatsapp.com/send?text=${encodedNewsHeading} ${url}`,
//       twitter: `https://twitter.com/intent/tweet?text=${encodedNewsHeading}&url=${url}`,
//       instagram: `https://www.instagram.com/`
//     };
//   };

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
//         {/* <Circles height="30" width="30" color="#f7265c" ariaLabel="loading" visible={true} /> */}
//       </div>
//     );
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   return (
//     <div>
//       <div className="row vc_row">
//         <div className="ak_vc_container">
//           <div className="wpb_column ak_column_3 vc_column_container">
//             <div className="ak_vc_wrapper wpb_wrapper">
//               <div
//                 className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
//                 id="block_65f7f61f36732_2"
//               >
//                 <div className="ak-block-inner clearfix">
//                   <div className="ak-block-posts clearfix">
//                     {news.map((post) => {
//                       const shareLinks = generateShareLinks(post.mainKhabarId, post.newsHeading);
//                       const htmlContent = isDesktop
//                         ? truncateHtml(post.newsTag, 100)
//                         : post.newsTag;
//                       return (

//                         <article key={post.mainKhabarId} className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news" style={{ border: "0.5px solid #d4d4d4ff", marginBottom: "20px" }}>
//                           <div className="ak-module-inner clearfix">
//                             <div className="ak-module-featured">
//                               <div className="ak-module-details mb-2">
//                                 <h1 className="ak-module-title">
//                                   <Link
//                                     to="#"
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       handleNewsClick2(post.slug, post.mainKhabarId);
//                                     }}
//                                     rel="bookmark"
//                                     aria-label="Shabd Today"
//                                     title={stripHtmlTags(post.newsTag)}
//                                   >
//                                     <span
//                                       className="responsive-font"
//                                       style={{ lineHeight: "30px" }}
//                                       dangerouslySetInnerHTML={{ __html: htmlContent }}
//                                     />
//                                   </Link>
//                                 </h1>
//                                 {/* <span className="tm-stmp"><FontAwesomeIcon icon={faClock} style={{ color: "crimson", fontSize: "12px" }} />&nbsp;
//                                   <span style={{ color: "" }}>{getTimeAgoInHindi(post.date)}
//                                   </span>
//                                 </span> */}
//                               </div>
//                               <div className="ak-featured-cover">
//                                 <Link
//                                   to="#"
//                                   onClick={(e) => {
//                                     e.preventDefault();
//                                     handleNewsClick2(post.slug, post.mainKhabarId);
//                                   }}
//                                   className="ak-featured-link"
//                                   rel="bookmark"
//                                   aria-label="Shabd Today"
//                                   title={stripHtmlTags(post.newsTag)}
//                                 >
//                                   <div className="ak-featured-thumb size-500">
//                                     <img
//                                       src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=245&h=123&outtype=webp"}
//                                       alt={stripHtmlTags(post.newsTag)}
//                                       width={410}
//                                       height={300}
//                                       loading="lazy"
//                                     />
//                                   </div>

//                                   {/* <div className="ak-featured-thumb  size-500">
//                                     <img
//                                       fetchpriority="high"
//                                       decoding="async"
//                                       width={410}
//                                       height={300}
//                                       loading="lazy"
//                                       src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=245&h=123&outtype=webp"}
//                                       className="attachment-newsy_360x180 size-newsy_360x180 lazyload wp-post-image"
//                                       alt={stripHtmlTags(post.newsTag)}
//                                       data-src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=245&h=123&outtype=webp"}
//                                       data-sizes="auto"
//                                       data-srcset={image_resize + "?url=" + baseUrl + post.newsImage + "&w=245&h=123&outtype=webp"}
//                                       data-expand={700}
//                                     />
//                                   </div> */}
//                                 </Link>
//                               </div>
//                             </div>

//                           </div>
//                         </article>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
//         {fetching && <p>Loading more news...</p>}
//         {!hasMore && <p>No more news available.</p>}
//       </div>
//     </div>
//   );

// };
// export default PoliticsCards

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import DOMPurify from 'dompurify';
import { Helmet } from "react-helmet";

const baseUrl = "https://api.shabdtoday.com/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";

const isDesktopScreen = () => window.innerWidth >= 1024;
const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }
  return text;
};

const truncateHtml = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const text = tempDiv.textContent || tempDiv.innerText || "";

  if (text.length <= maxLength) return html;

  let charCount = 0;
  let isTruncated = false;

  const traverse = (node) => {
    let newNode;
    if (node.nodeType === Node.TEXT_NODE) {
      if (charCount >= maxLength) return document.createTextNode("");
      const remaining = maxLength - charCount;
      const truncated = node.textContent.slice(0, remaining);
      charCount += truncated.length;
      if (charCount >= maxLength && !isTruncated) {
        isTruncated = true;
        newNode = document.createTextNode(truncated + "..."); // append dots
      } else {
        newNode = document.createTextNode(truncated);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      newNode = node.cloneNode(false);
      node.childNodes.forEach((child) => {
        if (charCount < maxLength) {
          newNode.appendChild(traverse(child));
        }
      });
    }
    return newNode;
  };

  const truncatedDiv = traverse(tempDiv);
  return truncatedDiv.outerHTML;
};


const local = "https://localhost:44351/api/home/pliticsKhabars"
const online = "https://api.shabdtoday.com/api/home/tajaKhabars"
// const online = "https://api.shabdtoday.com/api/home/pliticsKhabars"
const clicklocal = "https://localhost:44351/api/home/update-viewcount"
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};


const PoliticsCards = () => {
  const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const observer = useRef();

  // const fetchNews = async () => {
  //   if (!hasMore || fetching) return;

  //   setFetching(true);
  //   try {
  //     const response = await axios.get(`${online}?page=${page}&limit=5`);

  //     if (response.data && response.data.pliticsKhabars.length > 0) {
  //       setNews((prevNews) => {
  //         const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
  //         const newNews = response.data.pliticsKhabars.filter((item) => !existingIds.has(item.mainKhabarId));
  //         return [...prevNews, ...newNews];
  //       });
  //       setPage((prevPage) => prevPage + 1);
  //     } else {
  //       setHasMore(false);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching news:", error.message);
  //   }
  //   setFetching(false);
  //   setLoading(false);
  // };
  const fetchNews = async () => {
    if (!hasMore || fetching) return;

    setFetching(true);
    try {
      const response = await axios.get(`${online}?page=${page}&limit=5`);

      if (response.data && response.data.tazaKhabars.length > 0) {
        setNews((prevNews) => {
          const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
          const newNews = response.data.tazaKhabars.filter((item) => !existingIds.has(item.mainKhabarId));
          return [...prevNews, ...newNews];
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching news:", error.message);
    }
    setFetching(false);
    setLoading(false);
  };

  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchNews();
      }
    });

    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);

    return () => observer.current && observer.current.disconnect();
  }, [news]);

  const renderHtmlContent = (html) => {
    const sanitizedHtml = DOMPurify.sanitize(html);
    return { __html: sanitizedHtml };
  };

  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      const response = await axios.post(`${clickonline}`, {
        mainKhabarId: mainKhabarId
      });

      if (response.status === 200) {
        // console.log("View count updated successfully", response.data);
        window.location.href = `/News-Details/${slug}`;
      } else {
        console.error("Failed to update view count", response.data);
      }
    } catch (error) {
      console.error("Error updating view count:", error.response ? error.response.data : error.message);
    }
  };

  const handleNewsClick = (trendingTagId) => {
    navigate(`/NewsDetails/${trendingTagId}`);
  };

  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const seconds = date.getSeconds();
    const minute = date.getMinutes();
    var hour = date.getHours();
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
  };

  const getTimeAgoInHindi = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} सेकंड पहले`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} मिनट पहले`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} घंटे पहले`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays} दिन पहले`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} महीने पहले`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} साल पहले`;
  };

  const generateShareLinks = (mainKhabarId, newsTag) => {
    const encodedNewsHeading = encodeURIComponent(newsTag);
    const url = `${window.location.origin}/TajaKhabarDetailsNews/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodedNewsHeading}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodedNewsHeading} ${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodedNewsHeading}&url=${url}`,
      instagram: `https://www.instagram.com/`
    };
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        {/* <Circles height="30" width="30" color="#ff6015" ariaLabel="loading" visible={true} /> */}
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <Helmet>
        <title>आज की राजनीति न्यूज़ हिंदी – देश-विदेश की राजनीतिक खबरें | ShabdToday</title>
        <meta name="title" content="आज की राजनीति न्यूज़ हिंदी – देश-विदेश की राजनीतिक खबरें | ShabdToday" />
        <meta name="description" content="भारत और दुनिया की राजनीति की ताज़ा खबरें, चुनाव अपडेट और नीति-विधान समाचार हिंदी में।" />
        <meta name="keywords" content="राजनीति न्यूज़ हिंदी, भारत राजनीति, चुनाव समाचार, नीति अपडेट" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ShabdToday Team" />
        <link rel="canonical" href="https://shabdtoday.com/Politics-News" />
        <meta property="og:title" content="राजनीति समाचार हिंदी – ShabdToday" />
        <meta property="og:description" content="चुनाव, नीति और राजनीति की ताज़ा खबरें हिंदी में।" />
        <meta property="og:url" content="https://shabdtoday.com/Politics-News" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "राजनीति समाचार – ShabdToday",
            "url": "https://shabdtoday.com/Politics-News",
            "description": "राजनीतिक अपडेट, चुनाव और नीति की खबरें हिंदी में।",
            "publisher": {
              "@type": "Organization",
              "name": "ShabdToday",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shabdtoday.com/design/images/logo-s.webp"
              }
            }
          })}
        </script>

      </Helmet>
      {/* <h1 className="visually-hidden">राजनीति समाचार हिंदी में</h1>
      <h2 className="visually-hidden">चुनाव, नीति और केंद्रीय राजनीति</h2>
      <h3 className="visually-hidden">देश और राज्य की राजनीतिक घटनाएं</h3> */}
      <div className="row vc_row">
        <div className="ak_vc_container">
          <div className="wpb_column ak_column_3 vc_column_container">
            <div className="ak_vc_wrapper wpb_wrapper">
              <div
                className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
                id="block_65f7f61f36732_2"
              >
                <div className="ak-block-inner clearfix">
                  <div className="ak-block-posts clearfix">
                    {news.map((post) => {
                      const shareLinks = generateShareLinks(post.mainKhabarId, post.newsHeading);
                      const htmlContent = isDesktop
                        ? truncateHtml(post.newsTag, 100)
                        : post.newsTag;
                      return (

                        <article key={post.mainKhabarId} className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news" style={{ border: "0.5px solid #d4d4d4ff", marginBottom: "20px" }}>
                          <div className="ak-module-inner clearfix">
                            <div className="ak-module-featured">
                              <div className="ak-module-details mb-2">
                                <h2 className="ak-module-title">
                                  <Link
                                    to={`/News-Details/${post.slug}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleNewsClick2(post.slug, post.mainKhabarId);
                                    }}
                                    rel="bookmark"
                                    aria-label="Shabd Today"
                                    title={stripHtmlTags(post.newsTag)}
                                  >
                                    <span
                                      className="responsive-font"
                                      style={{ lineHeight: "30px" }}
                                      dangerouslySetInnerHTML={{ __html: htmlContent }}
                                    />
                                  </Link>
                                </h2>
                              </div>
                              <div className="ak-featured-cover">
                                <Link
                                  to={`/News-Details/${post.slug}`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleNewsClick2(post.slug, post.mainKhabarId);
                                  }}
                                  className="ak-featured-link"
                                  rel="bookmark"
                                  aria-label="Shabd Today"
                                  title={stripHtmlTags(post.newsTag)}
                                >
                                  <div className="ak-featured-thumb size-500">
                                    <img
                                      src={baseUrl + post.newsImage}
                                      alt={post.slug}
                                      width={600}
                                      height={300}
                                    />
                                  </div>
                                </Link>
                              </div>
                            </div>

                          </div>
                        </article>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
        {fetching && <p>Loading more news...</p>}
        {!hasMore && <p>No more news available.</p>}
      </div>
    </div>
  );

};
export default PoliticsCards
